// extracted by mini-css-extract-plugin
export default {"closer":"MNgIr","content":"fCEkx","description":"JJNwv","skeleton-progress":"_2450u"};